import React from 'react';
import { observer } from 'mobx-react';
import ManageRawGenericMappingComponentVM from './ManageRawGenericMappingComponentVM';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { ModalUtils, Validation } from '@singularsystems/neo-core';

interface IManageRawGenericMappingComponentProps {
    viewModel: ManageRawGenericMappingComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageRawGenericMappingComponentView extends React.Component<IManageRawGenericMappingComponentProps> {

    public render() {
        var viewModel = this.props.viewModel;
        return (
            <>
                {<Neo.Card title={`${viewModel.managedGenericMapping.rawGenericMappingID === 0 ? TextConstants.Titles.AddGenericMapping : TextConstants.Titles.EditGenericMapping}`}>
                    <>
                        <Neo.Form model={viewModel.managedGenericMapping}
                            onSubmit={() => this.props.onSave()}
                            validationDisplayMode={Validation.DisplayMode.AfterBlur}
                            onInvalid={this.onFormInvalid}>
                            <div className="row">
                                <div className="col-lg-4">
                                    {viewModel.managedGenericMapping.meta.rawGenericMappingID.value === 0 &&
                                        <Neo.FormGroup bindContext={viewModel.managedGenericMapping.meta.fileTypeConcatenated} label={TextConstants.Labels.FileType}>
                                            <Neo.AutoCompleteDropDown
                                                itemSource={viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria}
                                                bind={viewModel.managedGenericMapping.meta.staticFileSpecID}
                                                bindDisplay={viewModel.managedGenericMapping.meta.fileTypeConcatenated}
                                                displayMember={"propertiesConcatenated"} 
                                                items={viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                                .sort((x,y)=> x.propertiesConcatenated.localeCompare(y.propertiesConcatenated)))}    
                                            />
                                        </Neo.FormGroup>}
                                    {viewModel.managedGenericMapping.meta.rawGenericMappingID.value > 0 &&
                                        <Neo.FormGroup
                                            display={viewModel.managedGenericMapping.meta.fileSpecProperties}
                                            isReadOnly={viewModel.isFieldReadOnlyInd}
                                            label={TextConstants.Labels.FileType} />}
                                </div>
                                <div className="col-lg-4">
                                    <Neo.FormGroup
                                        label={TextConstants.Labels.SourceTable}
                                        bind={viewModel.managedGenericMapping.meta.rawGenericSourceTableName}
                                        isReadOnly={viewModel.isFieldReadOnlyInd} />
                                </div>
                                <div className="col-lg-4">
  
                                </div>
                            </div>
                                <Neo.GridLayout lg={3}>
                                    <Neo.RadioList className="pt-2 pb-2"
                                        bind={viewModel.managedGenericMapping.meta.sourceFieldIsCalculatedInd}
                                        radioList={{ items: [{ id: false, text: TextConstants.Labels.MappedDirectlyFromSourceField }, { id: true, text: TextConstants.Labels.Calculation }], inline: true }}
                                        onChange={() => viewModel.setSourceFieldValuesToFalse()} />
                                </Neo.GridLayout>

                            <div className="row">
                                {viewModel.managedGenericMapping.sourceFieldIsCalculatedInd &&
                                    <div className="col-lg-4">
                                        <Neo.FormGroup
                                            label={TextConstants.Labels.SourceField}
                                            bind={viewModel.managedGenericMapping.meta.rawGenericSourceField}
                                            onChange={() => viewModel.validateSourceFieldValue()}
                                            select={{ items: viewModel.sourceFieldList, displayMember: "sourceFieldName", valueMember: "sourceFieldName", allowNulls: true }} />
                                    </div>
                                }
                                {!viewModel.managedGenericMapping.sourceFieldIsCalculatedInd &&
                                    <div className="col-lg-4">
                                        <Neo.FormGroup
                                            label={TextConstants.Labels.SourceField}
                                            bind={viewModel.managedGenericMapping.meta.rawGenericSourceField} />
                                    </div>
                                }
                                {((viewModel.sourceFieldIsCalculation && viewModel.managedGenericMapping.sourceFieldIsCalculatedInd)
                                    || (viewModel.managedGenericMapping.meta.rawGenericSourceField.value === TextConstants.SourceFieldStaticOptions.Calc)) &&
                                    <div className="col-lg-4">
                                        <Neo.FormGroup
                                            bind={viewModel.managedGenericMapping.meta.calculation}
                                            input={{ rows: 3 }} />
                                    </div>}
                                {((viewModel.sourceFieldIsDefault && viewModel.managedGenericMapping.sourceFieldIsCalculatedInd)
                                    || (viewModel.managedGenericMapping.meta.rawGenericMappingID.value > 0
                                        && viewModel.managedGenericMapping.meta.rawGenericSourceField.value === TextConstants.SourceFieldStaticOptions.Default)) &&
                                    <div className="col-lg-4">
                                        <Neo.FormGroup
                                            bind={viewModel.managedGenericMapping.meta.defaultValue} />
                                    </div>}
                                {viewModel.sourceFieldIsFreeText && viewModel.managedGenericMapping.sourceFieldIsCalculatedInd &&
                                    <div className="col-lg-4">
                                        <Neo.FormGroup
                                            bind={viewModel.managedGenericMapping.meta.rawGenericSourceField}
                                        />
                                    </div>}
                            </div>
                            <Neo.GridLayout lg={3}>
                                <Neo.FormGroup
                                            label={TextConstants.Labels.DestinationTable}
                                            bind={viewModel.managedGenericMapping.meta.destinationTableId}
                                            select={{ items: viewModel.destinationTableList, displayMember: "destinationTableName", valueMember: "destinationTableId" }} 
                                            onClick={() => viewModel.setDestinationTableName(viewModel.managedGenericMapping.meta.destinationTableId.value)}/>
                                            
                                <Neo.FormGroup bindContext={viewModel.managedGenericMapping.meta.rawGenericDestinationField} label={TextConstants.Labels.DestinationField}>
                                    <Neo.AutoCompleteDropDown
                                        itemSource={(searchValue) => viewModel.rawGenericMappingApiClient.getDestinationFieldListByCriteria(searchValue, viewModel.managedGenericMapping.meta.destinationTableId.value as number)}
                                        bind={viewModel.managedGenericMapping.meta.destinationFieldId}
                                        bindDisplay={viewModel.managedGenericMapping.meta.rawGenericDestinationField}
                                        displayMember={"destinationFieldName"}
                                        isReadOnly={viewModel.managedGenericMapping.meta.destinationTableId.value === 0}
                                        items={viewModel.rawGenericMappingApiClient.getDestinationFieldListByCriteria(" ", viewModel.managedGenericMapping.meta.destinationTableId.value as number).then((arr) => arr.data.slice(0,10)
                                        .sort((x,y)=> x.destinationFieldName.localeCompare(y.destinationFieldName)))}
                                    />
                                </Neo.FormGroup>
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={6}>
                                <Neo.FormGroup
                                    bind={viewModel.managedGenericMapping.meta.iteration} />
                                <Neo.FormGroup className="pt-4"
                                    label={TextConstants.Labels.GenericJoinField}
                                    bind={viewModel.managedGenericMapping.meta.genericJoinFieldInd} />
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </>
                </Neo.Card>

                }
            </>
        );
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidGenericMapping);
        }
    }
}